export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11922.c0611132.jpg";